<script lang="ts">
    import {getContext, onMount, setContext} from 'svelte';
    import { openShare } from './src/client'
    import { type ShareLink } from './src/types'
    import Team from './Team.svelte'
    import Players from './Players.svelte'
    import Sheet from './Sheet.svelte'
    import Fa from 'svelte-fa/src/fa.svelte';
    import { faPerson, faPeopleGroup, faSheetPlastic, faRightFromBracket, faShare} from '@fortawesome/free-solid-svg-icons/index.js';

    enum displayMode {
        team = 0,
        sheet = 1,
        players = 3
    }

    const setAuthenticated = getContext<(boolean) => void>('setAuthenticated');
    

    export let link:string;

    let shareLink : ShareLink;

    let display : displayMode = displayMode.team;

    let sheetID : number;

    onMount(async() => {
        setAuthenticated(false);
        let openLink = await openShare(link);
        if (openLink) {
            shareLink = openLink;
        }
    })

    let displaySheet = (id:number) => {
        setAuthenticated(false);
        sheetID = id;
        display = displayMode.sheet;
    }

    let setDisplay = (mode : displayMode) => {
        setAuthenticated(false);
        display = mode;
    }

</script>

{#if shareLink} 

<h1 style='text-align: center;font-style: italic;font-weight: bold;color: var(--color-secondary);'>{shareLink.team} - {shareLink.season}</h1>

<div style="display:flex;flex-direction:row">    
    <button on:click={() => {setDisplay(displayMode.players)}} style="float:left; width:100%"><Fa icon="{faPerson}" size="2x"/>vue joueurs</button>
    <button on:click={() => {setDisplay(displayMode.team)}} style="float:right; width: 100%"><Fa icon="{faPeopleGroup}" size="2x"/>vue équipe</button>           
</div>

{#if display == displayMode.team}
    <Team guest={true} currentSeason={shareLink.season} currentTeam={shareLink.team} params={undefined} displaySheet={displaySheet}/>
{:else if display == displayMode.players}
    <Players guest={true} season={shareLink.season} team={shareLink.team} params={undefined} displaySheet={displaySheet}/>
{:else}
    <Sheet id={sheetID} guest={true} params={undefined} />
{/if}


{:else}
<h2>You naughty hacker ! stop trying forge a share link !</h2>
{/if}